module.exports = __webpack_public_path__ + "img/gzhma.54b17ff3.jpg";